<div class="spinner" [ngClass]="{ black: color == 'black' ,white:color==='white'}"></div>
